import { BaseManager } from "./index.js";
import { PlatformService } from "@/modules/api.js";

export class TeamManager extends BaseManager {
  _ServiceClass = PlatformService;

  dataProps = {
    available_trades: "number",
    bench: "object",
    congress: "object",
    created: "string",
    id: "number",
    league: "number",
    misc: "object",
    name: "string",
    owners: "object",
    settings: "object",
    total_points: "number",
    updated: "string"
  };

  get(leagueId, teamId) {
    const path = `/api/leagues/${leagueId}/teams/${teamId}/`;
    return this._get(path);
  }

  /* Utilities */

  // Drop a member of Congress from a team.
  drop(memberId) {
    const form = new URLSearchParams({
      member: memberId
    });
    const path = `/api/leagues/${this.data.league}/teams/${this.data.id}/drop/`;

    return this._post(path, form);
  }

  isUserOwner(userId) {
    return this.data.owners.find(u => u.id == userId) ? true : false;
  }
}
